import * as R from 'ramda';
export function getCache(cache, ...key) {
    const cacheKeys = key.slice(0, -1);
    return R.reduce((c, fragment) => {
        return c.get(fragment) || c.set(fragment, new Map()).get(fragment);
    }, cache, cacheKeys);
}
